import React, { useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { FieldsContainer, Link, Pill } from "../../constants/assets/containers";
import { FieldHolder } from "../../constants/assets/DriverDetailsContainers";
import QcDocumentDetailFields from "../../constants/QcDetails/QcDocumentDetailFields.json";
import { getPath } from "../../utils";
import DriverDocumentModal from "../Common/DriverDocumentModal";

const QcDriverDocumentDetails = ({ details = {} }) => {
  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState("");

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDocClick = (file) => {
    setModalContent(file);
    setShowModal(true);
  };

  const getValue = (field) => {
    if (!getPath(details, field.valuePath, "")) {
      return "NA";
    }
    let doc = getPath(details, field.valuePath, "");
    if (field.type === "date") {
      return doc[field.valueKey] ? moment(doc[field.valueKey]).format("DD-MM-YYYY") : "NA";
    }    

    return doc[field.valueKey];
  };

  const getRequiredFlag = (field) => {
    return getPath(details, field.valuePath, "")["required"];
  };

  const getQcDocType = (field) => {
    var doc_type = getPath(details, field.valuePath + ".doc_type", "");
    if (doc_type) {
      return " (" + doc_type + ")";
    } else {
      return "";
    }
  };

  const getUrlValue = (field) => {
    return (
      <Link
        onClick={() =>
          handleDocClick(getPath(details, field.valuePath, "")[field.urlKey])
        }
      >
        {getPath(details, field.valuePath, "")["file_name"] || "View"}
      </Link>
    );
  };

  const getVerifiedValue = (field) => {
    if (
      !getPath(details, field.valuePath, "") ||
      ["aadhar_card_doc"].includes(field.key)
    ) {
      return "NA";
    }

    const isVerified = getPath(details, field.valuePath, "")["verified"];
    if (isVerified === true || isVerified === false) {
      return (
        <Pill isFalse={!isVerified}>
          {isVerified ? "ACCEPTED" : "REJECTED"}
        </Pill>
      );
    }

    return "PENDING";
  };

  return [
    <QcDocumentDetailsContainer>
      <FieldsContainer>
        {getPath(Object.keys(details), "length", 0) > 0 &&
          Object.keys(details.document_details).map((field, index) => {
            return (
              QcDocumentDetailFields[field] &&
              getRequiredFlag(QcDocumentDetailFields[field]) && (
                <FieldHolder data-testId="qcDocumentField" key={field + index}>
                  <span className="row-heading">
                    {QcDocumentDetailFields[field].heading +
                      getQcDocType(QcDocumentDetailFields[field])}
                  </span>
                  <p className="row-text field-val">
                    {getValue(QcDocumentDetailFields[field])}
                  </p>
                  <p className="row-text url-val">
                    {getUrlValue(QcDocumentDetailFields[field])}
                  </p>
                  <p className="row-text verified-pill">
                    {getVerifiedValue(QcDocumentDetailFields[field])}
                  </p>
                </FieldHolder>
              )
            );
          })}
      </FieldsContainer>
    </QcDocumentDetailsContainer>,
    <DriverDocumentModal
      showModal={showModal}
      handleClose={handleClose}
      modalContent={modalContent}
    />,
  ];
};

const QcDocumentDetailsContainer = styled.div`
  .row-heading {
    flex: 0 1 20%;
  }
  .field-val,
  .url-val {
    flex: 0 1 25%;
  }
  .verified-pill {
    flex: 0 1 20%;
  }
`;

export default QcDriverDocumentDetails;
